import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ManageUsersService } from './manage-users.service';
import * as fromRoot from '../../../../state/app.state';
import { Observable, of } from "rxjs";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { FetchClinicFilterModel } from "../models/fetch-clinic-filter.model";
import { FetchStatusFilterModel } from "../models/fetch-status-filter.model";
import {
  AssignUserToNewGroupFailure,
  AssignUserToNewGroupRequest,
  AssignUserToNewGroupSuccess,
  EditProfileByUserIdFailure,
  EditProfileByUserIdRequest,
  EditProfileByUserIdSuccess,
  FetchClinicFilterFailure,
  FetchClinicFilterRequest,
  FetchClinicFilterSuccess,
  FetchGroupFilterFailure,
  FetchGroupFilterRequest,
  FetchGroupFilterSuccess,
  FetchRolesListFailure,
  FetchRolesListRequest,
  FetchRolesListSuccess,
  FetchStatusFilterFailure,
  FetchStatusFilterRequest,
  FetchStatusFilterSuccess,
  FetchUsersListFailure,
  FetchUsersListRequest,
  FetchUsersListSuccess, ResendInviteFailure, ResendInviteRequest, ResendInviteSuccess,
  UpdateUserStatusFailure,
  UpdateUserStatusRequest,
  UpdateUserStatusSuccess
} from './manage-users.actions';
import { FetchUsersListModel } from "../models/fetch-users-list.model";
import {
  RoleListResponse
} from '../../resources-hub/model/resource-details.model';
import { FetchGroupFilterModel } from "../models/fetch-group-filter.model";
import { EditProfileModel } from "../../../shared/models/edit-profile.model";
import { CommonService } from "../../../shared/services/common.service";

@Injectable()
export class ManageUsersEffects {
  fetchClinicFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchClinicFilterRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.manageUserService.fetchClinicFilter(payload).pipe(
          map((response: FetchClinicFilterModel['response']) => {
            const { data, message } = response;
            return FetchClinicFilterSuccess({
              data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchClinicFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchClinicFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchClinicFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );

  fetchGroupFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupFilterRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.manageUserService.fetchGroupFilter(payload).pipe(
          map((response: FetchGroupFilterModel['response']) => {
            const { data, message } = response;

            return FetchGroupFilterSuccess({
              data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchGroupFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchGroupFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchGroupFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchStatusFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchStatusFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.manageUserService.fetchStatusFilter().pipe(
          map((response: FetchStatusFilterModel['response']) => {
            const { data, message } = response;
            return FetchStatusFilterSuccess({
              statusFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchStatusFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchStatusFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchStatusFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchUsersList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchUsersListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload: FetchUsersListModel['request']) =>
        this.manageUserService.fetchUsersList(payload).pipe(
          map((response: FetchUsersListModel['response']) => {
            const { data, message } = response;
            return FetchUsersListSuccess({
              data,
              message
            });
          }),
          catchError(() => {
            return of(FetchUsersListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchUsersListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchUsersListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  )
  fetchRolesList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchRolesListRequest),
      mergeMap((payload: any) =>
        this.manageUserService.fetchRoleList().pipe(
          map((response: RoleListResponse['response']) => {
            const data = response.data;

            return FetchRolesListSuccess({ roleList: data })
          }),
          catchError((err: any) => {
            return of(FetchRolesListFailure({ error: err }))
          }),
          tap((action: any) => {
            if (action.type === FetchRolesListSuccess.type) {
              //api success call
            } else if (action.type === FetchRolesListFailure.type) {
              //api success call
            }
          }
          )
        )
      )
    )
  )
  updateUserStatus$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(UpdateUserStatusRequest),
      map((action) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.manageUserService.updateUserStatus(payload).pipe(
          map((response: any) => {
            const { message } = response;
            return UpdateUserStatusSuccess({ message })
          }),
          catchError((err: any) => {
            return of(UpdateUserStatusFailure({ error: err }))
          }),
          tap((action: any) => {
            if (action.type === UpdateUserStatusSuccess.type) {
              this.commonService.closeDialog();
              this.commonService.notification(action.message, "success");
            } else if (action.type === UpdateUserStatusFailure.type) {
              //api success call
            }
          }
          )
        )
      )
    )
  )

  editProfileByUserId$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(EditProfileByUserIdRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.manageUserService.editProfile(payload).pipe(
          map((response: EditProfileModel["response"]) => {
            const { message } = response;
            return EditProfileByUserIdSuccess({
              message
            });
          }),
          catchError(() => {
            return of(EditProfileByUserIdFailure());
          }),
          tap((action: any) => {
            if (action.type === EditProfileByUserIdSuccess.type) {
              // Code to execute on API Success Action dispatch
              this.commonService.closeDialog();
              this.commonService.notification(action.message, "success");
            } else if (action.type === EditProfileByUserIdFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  assignUserToNewGroup$ = createEffect(() => this.actions.pipe(ofType(AssignUserToNewGroupRequest),
    map(action => action.payload),
    mergeMap(payload => {
      return this.manageUserService.assignUserToNewGroup(payload).pipe(
        map(response => {
          return AssignUserToNewGroupSuccess()
        }),
        catchError(err => of(AssignUserToNewGroupFailure())),
        tap((action: any) => {
          if (action.type === AssignUserToNewGroupSuccess.type) {
            this.commonService.closeDialog();
            this.commonService.notification("Group assigned successfully",'success')
            const appliedFilter = this.manageUserService.onUserFilterChange.value;
            this.manageUserService.onUserFilterChange.next(appliedFilter)
          } else if (action.type === AssignUserToNewGroupFailure.type) {
            // Code to execute on API Failure Action dispatch
          }

        })
      )
    })
  ))

  resendInvite$ = createEffect(() => this.actions.pipe(ofType(ResendInviteRequest),
    map(action => {
      this.commonService.startLoading();
      return action.payload;
    }),
    mergeMap(payload => {
      return this.manageUserService.resendInvite(payload).pipe(
        map(response => ResendInviteSuccess()),
        catchError(err => of(ResendInviteFailure())),
        tap((action: any) => {
          this.commonService.stopLoading();
          if (action.type === ResendInviteSuccess.type) {
            this.commonService.notification("Invitation resent to registered email.",'success')
          } else if (action.type === ResendInviteFailure.type) {
            // Code to execute on API Failure Action dispatch
          }
        })
      )
    })
  ));

  constructor(
    private store: Store<fromRoot.State>,
    private manageUserService: ManageUsersService,
    private commonService: CommonService,
    private actions: Actions,
  ) {
  }

}
